var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnonymous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3134_14823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3134_14823)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.958 58.3903C11.958 47.9989 20.3819 39.575 30.7733 39.575C41.1648 39.575 49.5887 47.9989 49.5887 58.3903V59.8956H11.958V58.3903Z",
    fill: "#919AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2465 26.6588C40.2465 31.9932 35.9221 36.3176 30.5877 36.3176C25.2532 36.3176 20.9289 31.9932 20.9289 26.6588C20.9289 21.3244 25.2532 17 30.5877 17C35.9221 17 40.2465 21.3244 40.2465 26.6588Z",
    fill: "#919AA3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnonymous);
export default __webpack_public_path__ + "static/media/icon_anonymous.626f9a36db0b8177c44d71187f55ef43.svg";
export { ForwardRef as ReactComponent };